"use strict";
/// <reference path="irep.js"/>

IREP.editpassword = (function () {
    var ddlLanguage;
    var hfPassChange, hfBio, hfHomeCountryCode, hfCellPhone, hfCultureCode, hfStorePosition, hfRetailChainId, dashCurrentPassword, dashNewPassword, dashNewPasswordConfirm, mtrPasswordNotMatch, mtrPasswordMustBe, mtrFailure, mtrSuccess;

    var IntelIdClicked = 0;
    var init = function (options) {
        var dataObj = {};
        dataObj.UserType = IREP.options.user.userType;
        dataObj.Site = IREP.options.user.site;
        dataObj.CountryCode = IREP.options.user.countryCode;
        hfPassChange: options.hfPassChange;
        hfBio: options.hfBio;
        hfHomeCountryCode: options.hfHomeCountryCode;
        hfCellPhone: options.hfCellPhone;
        hfCultureCode: options.hfCultureCode;
        hfStorePosition: options.hfStorePosition;
        hfRetailChainId: options.hfRetailChainId;
        dashCurrentPassword = options.dashCurrentPassword;
        dashNewPassword = options.dashNewPassword;
        dashNewPasswordConfirm = options.dashNewPasswordConfirm;
        mtrPasswordNotMatch = options.mtrPasswordNotMatch;
        mtrPasswordMustBe = options.mtrPasswordMustBe;
        mtrFailure = options.mtrFailure;
        mtrSuccess = options.mtrSuccess;

        AccountCheck(true);
        
        //Saves password if enter key is pressed instead of clicking button
        $(window).keydown(function (event) {
            if (event.keyCode == 13) {
                event.preventDefault();

                if ($("#divEditPasswordPlaceHolder").css("display") === "block")
                {
                    if (($('#divPasswordError').is(":visible") != true)) {
                        if ($(hfPassChange).val() == 1) {
                            if (AccountCheck() == false) { //if false, do not allow save to continue
                                return false;
                            }
                        }
                    }

                    var objAccount = {
                        PaxUID: IREP.options.user.currentUID,
                        OrigEmailAddress: IREP.options.user.email,
                        Password: $(options.dashNewPassword).val(),
                        UserType: IREP.options.user.userType,
                        GeoCode: IREP.options.user.geoCode
                    };

                    if (AccountCheck() == true) {
                        if (objAccount.EmailAddress != "" && object.dashNewPassword != "" ) {
                            
                            IREP.leaderboard.block($("#divEditPassword"));
                            IREP.callApi({
                                url: "/account/changepassword",
                                type: "POST",
                                data: {
                                    //PaxUID: IREP.options.user.currentUID,
                                    Username: IREP.options.user.email,
                                    OldPassword: $(options.dashCurrentPassword).val(),
                                    NewPassword: $(options.dashNewPassword).val()
                                },
                                secure: true
                            })
                                .done(function (data) {
                                    if (data.passwordChanged == 1) {
                                        $("#divPasswordError").html(mtrSuccess); $("#divPasswordError").show();
                                        ($("#divEditPassword")).unblock();
                                        $(options.dashCurrentPassword).val("");
                                        $(options.dashNewPassword).val("");
                                        $(dashNewPasswordConfirm).val("");
                                    }
                                    else {
                                        $("#divPasswordError").html(mtrFailure); $("#divPasswordError").show();
                                        ($("#divEditPassword")).unblock();
                                    }
                                })
                                .fail(function (data) {
                                    $("#divPasswordError").html(mtrFailure); $("#divPasswordError").show();
                                    ($("#divEditPassword")).unblock();
                                })
                        }
                    }
                }

                
                return false;
            }
        });
        //Saves password
        $("#divSavePassword").click(function () {
            
            if (($('#divPasswordError').is(":visible") != true)) {
                if ($(hfPassChange).val() == 1) {
                    if (AccountCheck() == false) { //if false, do not allow save to continue
                        return false;
                    }
                }
            }

            var objAccount = {
                PaxUID: IREP.options.user.currentUID,
                OrigEmailAddress: IREP.options.user.email,
                Password: $(options.dashNewPassword).val(),
                UserType: IREP.options.user.userType,
                GeoCode: IREP.options.user.geoCode
            };

           

            if (AccountCheck() == true) {
                if (objAccount.EmailAddress != "") {
                    
                    IREP.leaderboard.block($("#divEditPassword"));
                    IREP.callApi({
                        url: "/account/changepassword",
                        type: "POST",
                        data: {
                            //PaxUID: IREP.options.user.currentUID,
                            Username: IREP.options.user.email,
                            OldPassword: $(options.dashCurrentPassword).val(),
                            NewPassword: $(options.dashNewPassword).val()
                        },
                        secure: true
                    })
                        .done(function (data) {
                            if(data.passwordChanged == 1)
                            {
                                $("#divPasswordError").html(mtrSuccess); $("#divPasswordError").show();
                                ($("#divEditPassword")).unblock();
                                $(options.dashCurrentPassword).val("");
                                $(options.dashNewPassword).val("");
                                $(dashNewPasswordConfirm).val("");
                            }
                            else {
                                $("#divPasswordError").html(mtrFailure); $("#divPasswordError").show();
                                ($("#divEditPassword")).unblock();
                            }
                        })
                        .fail(function (data) {
                            $("#divPasswordError").html(mtrFailure); $("#divPasswordError").show();
                            ($("#divEditPassword")).unblock();
                        })
                }
            }
            return false;
        });

    };
    //Validates form
    var AccountCheck = function (pageLoad) {
        
        var b = true;
        var hf = $.trim($(hfPassChange).val());
        var cpw = $.trim($(dashCurrentPassword).val());
        var pw = $.trim($(dashNewPassword).val());
        var pc = $.trim($(dashNewPasswordConfirm).val());
        

        var g = IREP.options.user.geoCode;

        var upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var lower = upper.toLowerCase();
        var number = "1234567890";
        var special = "|[!\"#$%&'()*+,-./:;=>?@[\]^_`{|}~]";

        if (typeof pageLoad == "undefined") {
            hf = 1;
        }
        if (pageLoad == true) {
            hf = 0;
        }

        $("#divPasswordError").hide();
        if (cpw == "" && hf == 0)
        {
            b = false;
            $("#divPasswordError").html(mtrFailure);
            $("#divPasswordError").show();
        }
        if (pw != pc) { b = false; $("#divPasswordError").html(mtrPasswordNotMatch); $("#divPasswordError").show(); }
        if (((pw == "") || (pc == "")) && cpw != "")
        {
            b = false; $("#divPasswordError").html(mtrPasswordMustBe); $("#divPasswordError").show();
        }
        if ((pw != "") && (pc != "") && (cpw != "")) {
            if (pw.length < 6) { b = false; $("#divPasswordError").html(mtrPasswordMustBe); $("#divPasswordError").show(); }
            if ((myContains(pw, upper) == false) && (myContains(pw, lower) == false)) { b = false; $("#divPasswordError").html(mtrPasswordMustBe); $("#divPasswordError").show(); }
            if (myContains(pw, number) == false) { b = false; $("#divPasswordError").html(mtrPasswordMustBe); $("#divPasswordError").show(); }
            if (myContains(pw, special) == false) { b = false; $("#divPasswordError").html(mtrPasswordMustBe); $("#divPasswordError").show(); }
        }

        return b;
    }

    

    
    var myContains = function (password, validChars) {
        for (var i = 0; i < password.length; i++) {
            var char = password.charAt(i);
            if (validChars.indexOf(char) > -1) {
                return true;
            }
        }
        return false;
    }

    

    return {
        init: init,
        AccountCheck: AccountCheck
        
    };
})();